// eslint-disable-next-line @typescript-eslint/no-explicit-any
function buildParamsStr<T extends Record<string, any>>(obj: T) {
  const params = new URLSearchParams();

  Object.keys(obj).forEach((key) => {
    const field = obj[key];

    if (Array.isArray(field) && field?.length) {
      params.append(key, field ? String(field) : '');
    } else if (
      !Array.isArray(field) &&
      (field !== undefined || field?.toString() === 'false')
    ) {
      params.append(key, String(field));
    }
  });

  return params.toString();
}

export default buildParamsStr;
